export const VENDOR_TRADES = [
  'extermination',
  'appliance_repair',
  'windows',
  'plumbing',
  'electrical',
  'hvac',
  'cleaning',
  'locksmith',
  'landscaping',
  'general_contractor',
  'other',
] as const;
export type VendorTrade = (typeof VENDOR_TRADES)[number];

export const VENDOR_TRADE_LABELS: Record<VendorTrade, string> = {
  extermination: 'Extermination',
  appliance_repair: 'Appliance repair',
  windows: 'Windows',
  plumbing: 'Plumbing',
  electrical: 'Electrical',
  hvac: 'HVAC',
  cleaning: 'Cleaning',
  locksmith: 'Locksmith',
  landscaping: 'Landscaping',
  general_contractor: 'General contractor',
  other: 'Other',
};

export const EXTERMINATION_OUTCOMES = [
  'serviced',
  'no_access',
  'refused',
  'not_required',
  'follow_up_required',
] as const;
export type ExterminationOutcome = (typeof EXTERMINATION_OUTCOMES)[number];

export const EXTERMINATION_OUTCOME_LABELS: Record<ExterminationOutcome, string> = {
  serviced: 'Serviced',
  no_access: 'No access',
  refused: 'Refused',
  not_required: 'Not required',
  follow_up_required: 'Follow-up required',
};

export const PEST_TYPES = [
  'roaches',
  'bedbugs',
  'rodents',
  'ants',
  'flies',
  'other',
] as const;
export type PestType = (typeof PEST_TYPES)[number];

export const VENDOR_UPLOAD_KINDS = ['work_order_photo', 'work_order_signature'] as const;
export type VendorUploadKind = (typeof VENDOR_UPLOAD_KINDS)[number];
